export enum ShuttleProvider {
  ABC = 'abc',
  Mexicoach = 'mexicoach',
  Damaris = 'damaris',
}
